import React from "react";
import local from "../../localization/strings";

const SMSUsage = ({ limit, remaining, siteId }) => {
	let remainingPercent = limit === 0 ? (remaining > 0 ? 100 : 0) : (remaining / limit) * 100;
	remainingPercent = Math.min(100, Math.max(0, remainingPercent));

	const progressHeight = "15px";
	const bgColor = remainingPercent > 20 ? "bg-success" : remainingPercent > 0 ? "bg-warning" : "bg-danger";

	return (
		<div className="progress" id={`sms-usage-${siteId}`} style={{ height: progressHeight }} title={`${local.TF_SMS_Segments_Remaining}: ${remaining}`}>
			<div className={`progress-bar ${bgColor}`} role="progressbar" style={{ width: Math.ceil(remainingPercent) + "%", height: progressHeight }} />
		</div>
	);
};

export default SMSUsage;
